import { toDate as t } from "./toDate.js";
function c(o, e) {
  const n = +t(o), [r, i] = [
    +t(e.start),
    +t(e.end)
  ].sort((s, a) => s - a);
  return n >= r && n <= i;
}
export {
  c as default,
  c as isWithinInterval
};
//# sourceMappingURL=isWithinInterval.js.map
